<template>
    <div class="news">
        <div class="bgImg">
            <img src="../assets/aem/pbg.png" alt="">
        </div>
        <div class="mCon">
            <div class="t1 wow fadeInUp">
                <div class="title">
                    <p>案例中心</p>
<!--                    <p> Amuer brings you the pure elegant life</p>-->
                </div>
            </div>
            <div class="allNews wow fadeInUp">
                <swiper class="swiper" :options="swiperOption" ref="mySwipers">
                    <swiper-slide class="item" v-for="(item,index) in cases" :key="index">
                        <div class="info" @click="gotoInfo(item.id)">
                            <p class="name">{{item.title}}</p>
                            <div class="pic">
                                <img :src="`http://www.bodenstil.com/${item.case_pic}`" alt="">
                                <div class="txt">
                                    <p class="t2">{{item.title}}</p>
                                    <p class="t3">{{item.description}}</p>
                                </div>
                            </div>
                        </div>

                    </swiper-slide>
                </swiper>
                <swiper class="swiper2" :options="swiperOption2" ref="mySwipers2">
                    <swiper-slide class="item" v-for="(item,index) in cases" :key="index">
                        <div class="one">

                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="btn prev ">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="btn next ">
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>

    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "news",
        data(){
            return{
                swiperOption:{
                    notNextTick: true,
                    speed:1000,
                    init:false,
                    loop:true,
                    centeredSlides : true,
                    slidesPerView : 3,
                    spaceBetween :60,
                    initialSlide :1,
                    setWrapperSize :true,
                    autoplay: false,
                    pagination: {
                        el: '.news .swiper-pagination',
                        type: 'fraction'
                    },
                    navigation: {
                        prevEl: '.news .btn.prev',
                        nextEl: '.news .btn.next',
                    },
                    breakpoints: {
                        1000: {
                            //当屏幕宽度大于等于1280
                            slidesPerView: 1,
                            spaceBetween: 30,
                        },
                    },
                },
                swiperOption2:{
                    notNextTick: true,
                    speed:1000,
                    init:false,
                    loop:true,
                    centeredSlides : true,
                    slidesPerView : 3,
                    spaceBetween :60,
                    initialSlide :1,
                    setWrapperSize :true,
                    autoplay: false,
                    breakpoints: {
                        1000: {
                            //当屏幕宽度大于等于1280
                            slidesPerView: 1,
                            spaceBetween: 30,
                        },
                    }
                }
            }
        },
        props:[
            'cases'
        ],
        components:{
            swiper, swiperSlide
        },
        mounted(){
            setTimeout(()=>{
                this.$refs.mySwipers.swiper.init()
                this.$refs.mySwipers2.swiper.init()
                const swiperTop = this.$refs.mySwipers.swiper
                const swiperThumbs = this.$refs.mySwipers2.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
            },100)
        },
        methods:{
            gotoNews(){
                const  link='./news.html'
                window.open(link,'_self')
            },
            gotoInfo(id){
                const  link=`./caseInfo.html?id=${id}`
                window.open(link,'_self')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .news {
        width: 100%;
        position: relative;
        .bgImg {
            width: 100%;
            img {
                width: 100%;
                display: block;
                object-fit: cover;
                height: 900px;
            }
        }
        .mCon {
            width: 100%;
            left: 0;
            top: 40px;
            position: absolute;
            .t1 {
                width: 80%;
                margin: 0 auto;
                border-bottom: 1px solid rgba(97, 96, 90, 0.1);
                padding: 20px 0;
                .title {
                    p:nth-child(1) {
                        font-size: 24px;
                        font-family: "DINNeuzeitGroteskStd-Light";
                        text-transform: uppercase;
                    }
                    p:nth-child(2) {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        font-family: "it";
                        font-weight: lighter;
                        font-size: 14px;
                        margin: 15px auto;
                        &::before {
                            width: 30px;
                            height: 1px;
                            background: rgba(187, 187, 187, 1);
                            content: "";
                            display: inline-block;
                            margin-right: 10px;
                        }
                    }
                }
            }
            .allNews {
                width: 90%;
                margin: 60px 0 0 10%;
                position: relative;
                &::after {
                    content: "";
                    display: inline-block;
                    border: 1px dashed black;
                    width: 100%;
                    position: absolute;
                    bottom: 1.5%;
                }
                .swiper {
                    width: 100%;
                    padding: 60px 0;
                    height: 400px;
                    .item {
                        cursor: pointer;
                        .info {
                            width: 80%;
                            margin: 0 auto;
                            transition: all 600ms;
                            transform: translateY(68px);
                            .name {
                                color: #4f4f4b;
                                font-family: "itbook";
                                text-transform: uppercase;
                                transition: all 600ms;
                            }
                            .pic {
                                width: 100%;
                                margin: 30px auto;
                                position: relative;
                                overflow: hidden;
                                img {
                                    width: 100%;
                                    display: block;
                                    object-fit: cover;
                                }
                                .txt {
                                    width: 90%;
                                    left: 5%;
                                    position: absolute;
                                    bottom: 5%;
                                    transition: all 600ms;
                                    transform: translateY(200px);
                                    opacity: 0;
                                }
                                .t2 {
                                    color: white;
                                    font-family: "itbook";
                                    text-transform: uppercase;
                                }
                                .t3 {
                                    font-size: 14px;
                                    color: white;
                                    font-family: "it";
                                    margin: 15px 0;
                                    line-height: 25px;
                                }
                            }
                        }
                    }
                    .swiper-slide-active {
                        .info {
                            width: 100%;
                            transform: translateY(0);
                            .name {
                                opacity: 0;
                                transform: translateY(100px);
                            }
                            .pic {
                                .txt {
                                    transform: translateY(0);
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
                .swiper2 {
                    width: 100%;
                    position: relative;
                    &::before {
                        content: "";
                    }
                    .item {
                        .one {
                            width: 1px;
                            height: 20px;
                            background: rgba(97, 96, 90, 1);
                            margin: 0 auto;
                        }
                    }
                }
            }
            .prev {
                position: absolute;
                right: 17%;
                top: 6%;
                color: rgba(79, 79, 75, 0.4);
                cursor: pointer;
                transition: all 1s;
                z-index: 1000;
                text-align: center;
                i {
                    font-size: 20px;
                }
            }
            .next {
                position: absolute;
                right: 12%;
                top: 6%;
                color: rgba(79, 79, 75, 0.4);
                cursor: pointer;
                transition: all 1s;
                z-index: 1000;
                text-align: center;
                i {
                    font-size: 20px;
                }
            }
            .btn:hover {
                color: #f7c66b;
            }
            .btn:focus {
                outline: none;
            }
        }
    }
    @media screen and (max-width: 1440px){
        .news{
            .mCon{
                top:80px;
            }
        }
    }
    @media screen and (max-width: 1000px) {
        .news {
            .bgImg {
                img {
                    height: 600px;
                }
            }
            .mCon {
                .t1 {
                    width: 90%;
                    .title {
                        p {
                            margin: 15px auto 25px auto !important;
                        }
                    }
                }
                .allNews {
                    width: 90%;
                    margin: 20px auto;
                    .swiper {
                        padding: 0;
                        height:300px;
                    }
                }
                .prev,
                .next {
                    top: 19%;
                }
                .prev {
                    right: 90%;
                }
                .next {
                    right: 70%;
                }
            }
            .swiper-pagination {
                top: 19% !important;
                left: 13% !important;
            }
        }
    }
</style>
<style scoped>
    .news .swiper-pagination{
        left:80%;
        width:10%;
        top:6%;
        position: absolute;
        height:30px;
    }
    .news .swiper-pagination >>> span{
        color:#61605A;
        font-family: "it";
    }
</style>
